export default __webpack_public_path__ + "static/media/genrateAcc.b3a8932f.svg";